import { render, staticRenderFns } from "./DetailModalBtn.vue?vue&type=template&id=40d8ea96&scoped=true"
import script from "./DetailModalBtn.vue?vue&type=script&lang=js"
export * from "./DetailModalBtn.vue?vue&type=script&lang=js"
import style0 from "./DetailModalBtn.vue?vue&type=style&index=0&id=40d8ea96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8ea96",
  null
  
)

export default component.exports